/* Sigges Fisk motion layer. Needs sigges-motion-lib.js (Motion 12 UMD, global `Motion`) loaded first.
   Everything is opt-in via data attributes so Horizon's own behaviour is untouched.
   Springs stay short (< .6s), one motion per element, reduced-motion respected. */
(function () {
  var M = window.Motion;
  if (!M) { document.documentElement.classList.remove('sf-js'); return; }
  var animate = M.animate, hover = M.hover, press = M.press, inView = M.inView, stagger = M.stagger;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch = window.matchMedia('(hover: none)').matches;
  var snap = { type: 'spring', visualDuration: 0.32, bounce: 0.18 };
  var rise = { type: 'spring', visualDuration: 0.55, bounce: 0.15 };

  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Buttons: lift on hover, squeeze on press ---------- */
  function wireButtons(root) {
    $all('.sf-btn, .button, product-card .button, [data-sf-press]', root).forEach(function (b) {
      if (b.dataset.sfBtnWired) return; b.dataset.sfBtnWired = '1';
      if (!touch) hover(b, function () { animate(b, { y: -2 }, snap); return function () { animate(b, { y: 0 }, snap); }; });
      press(b, function () { animate(b, { scale: 0.965 }, { duration: 0.08 }); return function () { animate(b, { scale: 1 }, { type: 'spring', visualDuration: 0.3, bounce: 0.3 }); }; });
      var arr = b.querySelector('.sf-arr');
      if (arr && !touch) hover(b, function () { animate(arr, { x: 4 }, snap); return function () { animate(arr, { x: 0 }, snap); }; });
    });
  }

  /* ---------- Add-to-cart confirmation (forms with data-sf-cart) ---------- */
  function wireCart(root) {
    $all('form[data-sf-cart]', root).forEach(function (f) {
      if (f.dataset.sfCartWired) return; f.dataset.sfCartWired = '1';
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = f.querySelector('button'), ok = f.querySelector('.sf-ok');
        if (!btn || btn.dataset.busy) return; btn.dataset.busy = '1';
        var fd = new FormData(f);
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function () {
            if (ok) animate(ok, { opacity: 1, y: 0 }, { type: 'spring', visualDuration: 0.35, bounce: 0.25 });
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
            var bubble = document.querySelector('.cart-bubble, [data-cart-count], .header-actions__cart-icon');
            if (bubble) animate(bubble, { scale: [1, 1.25, 1] }, { duration: 0.45 });
            setTimeout(function () { if (ok) animate(ok, { opacity: 0, y: '100%' }, { duration: 0.25, ease: 'easeIn' }); delete btn.dataset.busy; }, 1500);
          })
          .catch(function () { delete btn.dataset.busy; f.submit(); });
      });
    });
  }

  /* ---------- Ticker: constant speed, eases down on hover ---------- */
  function wireTickers(root) {
    $all('[data-sf-ticker]', root).forEach(function (t) {
      if (t.dataset.sfTickWired) return; t.dataset.sfTickWired = '1';
      var track = t.querySelector('.sf-ticker__track'); if (!track) return;
      var dir = parseFloat(t.dataset.dir || '1'), pxPerMs = parseFloat(t.dataset.speed || '0.045');
      var speed = 1, x = 0, last = performance.now();
      if (reduce) return;
      function half() { return track.scrollWidth / 2; }
      if (dir < 0) x = -half();
      function frame(now) {
        var dt = Math.min(now - last, 48); last = now;
        x -= dir * dt * pxPerMs * speed;
        var h = half();
        if (dir > 0 && -x >= h) x += h;
        if (dir < 0 && x >= 0) x -= h;
        track.style.transform = 'translate3d(' + x + 'px,0,0)';
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
      if (!touch) hover(t, function () { animate(1, 0.15, { duration: 0.4, onUpdate: function (v) { speed = v; } }); return function () { animate(0.15, 1, { duration: 0.5, onUpdate: function (v) { speed = v; } }); }; });
    });
  }

  /* ---------- Hero: words rise one by one, then the rest ---------- */
  function wireHero(root) {
    $all('[data-sf-hero]', root).forEach(function (hero) {
      if (hero.dataset.sfHeroWired) return; hero.dataset.sfHeroWired = '1';
      var h = hero.querySelector('[data-sf-words]');
      if (h && !h.dataset.split) {
        h.dataset.split = '1';
        h.innerHTML = h.textContent.trim().split(/\s+/).map(function (w) { return '<span class="sf-w">' + w + '</span>'; }).join(' ');
      }
      var words = $all('.sf-w', hero), rest = $all('[data-sf-rise]', hero);
      if (reduce) { words.concat(rest).forEach(function (el) { el.style.opacity = 1; el.style.transform = 'none'; }); return; }
      function play() {
        animate(words, { opacity: [0, 1], y: ['0.6em', '0em'] }, { delay: stagger(0.07, { startDelay: 0.1 }), type: 'spring', visualDuration: 0.55, bounce: 0.2 });
        animate(rest, { opacity: [0, 1], y: [12, 0] }, { delay: stagger(0.09, { startDelay: 0.45 }), duration: 0.45 });
      }
      /* The hero sits above the fold: play right away instead of waiting for an intersection callback */
      requestAnimationFrame(play);
    });
  }

  /* ---------- Cards: lift, image scale, CTA slides up ---------- */
  function wireCards(root) {
    $all('[data-sf-card]', root).forEach(function (c) {
      if (c.dataset.sfCardWired) return; c.dataset.sfCardWired = '1';
      var img = c.querySelector('.sf-card__img, img'), cta = c.querySelector('.sf-card__cta');
      if (touch) { if (cta) { cta.style.opacity = 1; cta.style.transform = 'none'; } return; }
      hover(c, function () {
        animate(c, { y: -4 }, snap);
        if (img) animate(img, { scale: 1.06 }, { type: 'spring', visualDuration: 0.5, bounce: 0.1 });
        if (cta) animate(cta, { opacity: 1, y: 0 }, snap);
        return function () {
          animate(c, { y: 0 }, snap);
          if (img) animate(img, { scale: 1 }, snap);
          if (cta) animate(cta, { opacity: 0, y: 8 }, { duration: 0.2 });
        };
      });
    });
    /* Horizon's own product cards get the image zoom only */
    if (!touch) $all('product-card', root).forEach(function (c) {
      if (c.dataset.sfCardWired) return; c.dataset.sfCardWired = '1';
      var img = c.querySelector('img'); if (!img) return;
      hover(c, function () { animate(img, { scale: 1.05 }, { type: 'spring', visualDuration: 0.5, bounce: 0.1 }); return function () { animate(img, { scale: 1 }, snap); }; });
    });
  }

  /* ---------- Accordion boxes (data-sf-acc > button + .sf-acc__panel) ---------- */
  function wireAccordions(root) {
    $all('[data-sf-acc]', root).forEach(function (q) {
      if (q.dataset.sfAccWired) return; q.dataset.sfAccWired = '1';
      var btn = q.querySelector('button'), panel = q.querySelector('.sf-acc__panel'), chev = q.querySelector('.sf-acc__chev');
      if (!btn || !panel) return;
      var inner = panel.firstElementChild;
      btn.addEventListener('click', function () {
        var open = q.classList.toggle('is-open'); btn.setAttribute('aria-expanded', open);
        var h = inner ? inner.offsetHeight : panel.scrollHeight;
        if (reduce) { panel.style.height = open ? 'auto' : '0px'; return; }
        animate(panel, { height: open ? [0, h] : [h, 0] }, { type: 'spring', visualDuration: 0.38, bounce: 0 }).then(function () { if (q.classList.contains('is-open')) panel.style.height = 'auto'; });
        if (chev) animate(chev, { rotate: open ? 180 : 0 }, snap);
      });
    });
    /* native <details> in article bodies: rotate the marker via class only */
  }

  /* ---------- Scroll reveal: once, small rise ---------- */
  function wireReveals(root) {
    var els = $all('[data-sf-reveal], .sf-reveal', root);
    if (reduce) { els.forEach(function (el) { el.style.opacity = 1; el.style.transform = 'none'; }); return; }
    els.forEach(function (el, i) {
      if (el.dataset.sfRevWired) return; el.dataset.sfRevWired = '1';
      var d = parseFloat(el.dataset.sfDelay || '0');
      inView(el, function () { animate(el, { opacity: 1, y: 0 }, Object.assign({ delay: d }, rise)); }, { amount: 0.25, once: true });
    });
  }

  function wireAll(root) {
    wireButtons(root); wireCart(root); wireTickers(root); wireHero(root); wireCards(root); wireAccordions(root); wireReveals(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { wireAll(document); });
  else wireAll(document);
  /* Theme editor re-renders sections */
  document.addEventListener('shopify:section:load', function (e) { wireAll(e.target); });
})();
